import { STORAGE_KEYS, getStorageItem } from '@/lib/pwa-storage'

/** Decisión de cookies guardada, o `null` si no hay ninguna válida. */
export type StoredConsent = 'accepted' | 'rejected'

/**
 * Único lector del consentimiento guardado. Lo usan el hook (`useCookieConsent`)
 * y lo que guarda datos de analítica fuera de PostHog (`lib/marketing-attribution`):
 * si el formato cambia (categorías, versión…), se toca aquí y no en cada lector.
 */
export function readStoredConsent(): StoredConsent | null {
  const stored = getStorageItem(STORAGE_KEYS.COOKIE_CONSENT)
  return stored === 'accepted' || stored === 'rejected' ? stored : null
}

export function hasStoredAnalyticsConsent(): boolean {
  return readStoredConsent() === 'accepted'
}
